module.exports = __webpack_public_path__ + "img/carton-ondulado.f75ebccb.jpg";